export const SUPPORTED_LOCALES = [
  'ar',
  'da',
  'de',
  'en-US',
  'es',
  'fi',
  'fr',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pt-BR',
  'ru',
  'sv',
  'uk',
  'zh-CN',
  'zh-HK',
];

export const COUNTRY_NAME_MAPPINGS: {
  [key: string]: { [key: string]: string };
} = {
  ar: {
    AU: 'أستراليا .',
    BR: 'البرازيل .',
    CN: 'الصين .',
    DK: 'الدانمرك',
    FI: 'فنلندا',
    FR: 'فرنسا .',
    DE: 'ألمانيا',
    HK: 'منطقة هونغ كونغ الإدارية الخاصة في الصين',
    IT: 'إيطاليا .',
    IN: 'الهند .',
    JP: 'اليابان .',
    KR: 'جمهورية كوريا',
    MX: 'المكسيك .',
    MY: 'ماليزيا .',
    NL: 'هولندا .',
    NO: 'النرويج',
    NZ: 'نيوزيلندا',
    RU: 'روسيا .',
    SE: 'سويسرا',
    TW: 'الصين تايوان',
    US: 'و { غ',
    VN: 'فييت نام',
  },
  da: {
    AU: 'Australien',
    BR: 'Brasilien',
    CN: 'Kina',
    DK: 'Danmark',
    FI: 'Finland',
    FR: 'Frankrig',
    DE: 'Tyskland',
    HK: 'Hong Kong S.A.R. of China',
    IT: 'Italien',
    IN: 'Indien',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexico',
    MY: 'Malaysia',
    NL: 'Nederlandene',
    NO: 'Norge',
    NZ: 'New Zealand',
    RU: 'Rusland',
    SE: 'Sverige',
    TW: 'Taiwan, Kina',
    US: 'USA',
    VN: 'Vietnam',
  },
  de: {
    AU: 'Australien',
    BR: 'Brasilien',
    CN: 'China',
    DK: 'Dänemark',
    FI: 'Finnland',
    FR: 'Frankreich',
    DE: 'Deutschland',
    HK: 'Hong Kong S.A.R. of China',
    IT: 'Italien',
    IN: 'Indien',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexiko',
    MY: 'Malaysia',
    NL: 'Niederlande',
    NO: 'Norwegen',
    NZ: 'Neuseeland',
    RU: 'Russland',
    SE: 'Schweden',
    TW: 'Taiwan,China',
    US: 'Vereinigte Staaten',
    VN: 'Vietnam',
  },
  'en-US': {
    AU: 'Australia',
    BR: 'Brazil',
    CN: 'China',
    DK: 'Denmark',
    FI: 'Finland',
    FR: 'France',
    DE: 'Germany',
    HK: 'Hong Kong S.A.R.of China',
    IT: 'Italy',
    IN: 'India',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexico',
    MY: 'Malaysia',
    NL: 'Netherlands',
    NO: 'Norway',
    NZ: 'New Zealand',
    RU: 'Russia',
    SE: 'Sweden',
    TW: 'Taiwan,China',
    US: 'United States',
    VN: 'Viet Nam',
  },
  es: {
    AU: 'Australia',
    BR: 'Brasil',
    CN: 'China',
    DK: 'Dinamarca',
    FI: 'Finlandia',
    FR: 'Francia',
    DE: 'Alemania',
    HK: 'Región Administrativa Especial de Hong Kong de China',
    IT: 'Italia',
    IN: 'India',
    JP: 'Japón',
    KR: 'Corea del Sur',
    MX: 'México',
    MY: 'Malasia',
    NL: 'Países Bajos',
    NO: 'Noruega',
    NZ: 'Nueva Zelanda',
    RU: 'Rusia',
    SE: 'Suecia',
    TW: 'Taiwán, China',
    US: 'Estados Unidos',
    VN: 'Vietnam',
  },
  fi: {
    AU: 'Australia',
    BR: 'Brasilia',
    CN: 'Kiina',
    DK: 'Tanska',
    FI: 'Suomi',
    FR: 'Ranska',
    DE: 'Saksa',
    HK: 'Hong Kong S.A.R.of China',
    IT: 'Italia',
    IN: 'Intia',
    JP: 'Japani',
    KR: 'Korea',
    MX: 'Meksiko',
    MY: 'Malesia',
    NL: 'Alankomaat',
    NO: 'Norja',
    NZ: 'Uusi-Seelanti',
    RU: 'Venäjä',
    SE: 'Ruotsi',
    TW: 'Taiwan,Kiina',
    US: 'Yhdysvallat',
    VN: 'Vietnam',
  },
  fr: {
    AU: 'Australie',
    BR: 'Brésil',
    CN: 'Chine',
    DK: 'Danemark',
    FI: 'Finlande',
    FR: 'France',
    DE: 'Allemagne',
    HK: 'Région administrative spéciale de Hong Kong, Chine',
    IT: 'Italie',
    IN: 'Inde',
    JP: 'Japon',
    KR: 'Corée du Sud',
    MX: 'Mexique',
    MY: 'Malaisie',
    NL: 'Pays - Bas',
    NO: 'Norvège',
    NZ: 'Nouvelle - Zélande',
    RU: 'Russie',
    SE: 'Suède',
    TW: 'Taïwan, Chine',
    US: 'États - Unis',
    VN: 'Vietnam',
  },
  it: {
    AU: 'Australia',
    BR: 'Brasile',
    CN: 'Cina',
    DK: 'Danimarca',
    FI: 'Finlandia',
    FR: 'Francia',
    DE: 'Germania',
    HK: 'Hong Kong S.A.R. della Cina',
    IT: 'Italia',
    IN: 'India',
    JP: 'Giappone',
    KR: 'Corea',
    MX: 'Messico',
    MY: 'Malaysia',
    NL: 'Paesi Bassi',
    NO: 'Norvegia',
    NZ: 'Nuova Zelanda',
    RU: 'Russia',
    SE: 'Svezia',
    TW: 'Taiwan,Cina',
    US: 'Stati Uniti',
    VN: 'Vietnam',
  },
  ja: {
    AU: 'オーストラリア',
    BR: 'ブラジル.',
    CN: '中国',
    DK: 'デンマーク.',
    FI: 'フィンランド.',
    FR: 'フランス.',
    DE: 'ドイツ.',
    HK: '中国香港特別行政区',
    IT: 'イタリア.',
    IN: 'インド.',
    JP: '日本',
    KR: '韓国',
    MX: 'メキシコ.',
    MY: 'マレーシア.',
    NL: 'オランダ.',
    NO: 'ノルウェー.',
    NZ: 'ニュージーランド.',
    RU: 'ロシア.',
    SE: 'スウェーデン.',
    TW: '台湾',
    US: 'アメリカ',
    VN: 'ベトナム.',
  },
  ko: {
    AU: '호주',
    BR: '브라질',
    CN: '중국',
    DK: '덴마크',
    FI: '핀란드',
    FR: '프랑스',
    DE: '독일',
    HK: '중국 홍콩 특별 행정구',
    IT: '이탈리아',
    IN: '인도',
    JP: '일본',
    KR: '한국',
    MX: '멕시코',
    MY: '말레이시아',
    NL: '네덜란드',
    NO: '노르웨이',
    NZ: '뉴질랜드',
    RU: '러시아',
    SE: '스웨덴',
    TW: '중국 대만',
    US: '미국',
    VN: '베트남',
  },
  nl: {
    AU: 'Australië',
    BR: 'Brazilië',
    CN: 'China',
    DK: 'Denemarken',
    FI: 'Finland',
    FR: 'Frankrijk',
    DE: 'Duitsland',
    HK: 'Hong Kong S.A.R. of China',
    IT: 'Italië',
    IN: 'India',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexico',
    MY: 'Maleisië',
    NL: 'Nederland',
    NO: 'Noorwegen',
    NZ: 'Nieuw-Zeeland',
    RU: 'Rusland',
    SE: 'Zweden',
    TW: 'Taiwan,China',
    US: 'Verenigde Staten',
    VN: 'Vietnam',
  },
  no: {
    AU: 'Australia',
    BR: 'Brasil',
    CN: 'Kina',
    DK: 'Danmark',
    FI: 'Finland',
    FR: 'Frankrike',
    DE: 'Tyskland',
    HK: 'Hong Kong S.A.R. av Kina',
    IT: 'Italia',
    IN: 'India',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexico',
    MY: 'Malaysia',
    NL: 'Nederland',
    NO: 'Norge',
    NZ: 'New Zealand',
    RU: 'Russland',
    SE: 'Sverige',
    TW: 'Taiwan, Kina',
    US: 'USA',
    VN: 'Viet Nam',
  },
  'pt-BR': {
    AU: 'Austrália',
    BR: 'Brasil',
    CN: 'China',
    DK: 'Dinamarca',
    FI: 'Finlândia',
    FR: 'França',
    DE: 'Alemanha',
    HK: 'Hong Kong S.A.R. da China',
    IT: 'Itália',
    IN: 'Índia',
    JP: 'Japão',
    KR: 'Coreia',
    MX: 'México',
    MY: 'Malásia',
    NL: 'Países Baixos',
    NO: 'Noruega',
    NZ: 'Nova Zelândia',
    RU: 'Rússia',
    SE: 'Suécia',
    TW: 'Taiwan, China',
    US: 'United States',
    VN: 'Viet Nam',
  },
  ru: {
    AU: 'Австралия',
    BR: 'Бразилия',
    CN: 'Китай',
    DK: 'Дания',
    FI: 'Финляндия',
    FR: 'Франция',
    DE: 'Германия',
    HK: 'Гонконг, специальный административный район Китая',
    IT: 'Италия',
    IN: 'Индия',
    JP: 'Япония',
    KR: 'Корея',
    MX: 'Мексика',
    MY: 'Малайзия',
    NL: 'Нидерланды',
    NO: 'Норвегия',
    NZ: 'НоваяЗеландия',
    RU: 'Россия',
    SE: 'Швеция',
    TW: 'Китай',
    US: 'США',
    VN: 'Вьетнам',
  },
  sv: {
    AU: 'Australien',
    BR: 'Brasilien',
    CN: 'Kina',
    DK: 'Danmark',
    FI: 'Finland',
    FR: 'Frankrike',
    DE: 'Tyskland',
    HK: 'Hong Kong S.A.R. of China',
    IT: 'Italien',
    IN: 'Indien',
    JP: 'Japan',
    KR: 'Korea',
    MX: 'Mexiko',
    MY: 'Malaysia',
    NL: 'Nederländerna',
    NO: 'Norge',
    NZ: 'Nya Zeeland',
    RU: 'Ryssland',
    SE: 'Sverige',
    TW: 'Taiwan, Kina',
    US: 'Förenta staterna',
    VN: 'Vietnam',
  },
  uk: {
    AU: 'Австраліяworld. kgm',
    BR: 'БразиліяCountry name',
    CN: 'КитаCountry name',
    DK: 'Даніяworld. kgm',
    FI: 'Фінляндіяworld. kgm',
    FR: 'Франція',
    DE: 'НімеччинаName',
    HK: 'Хонг Конг САР Китаю',
    IT: 'ІталіяCountry name',
    IN: 'Індія',
    JP: 'Японіяworld. kgm',
    KR: 'Корея',
    MX: 'Мексикаworld. kgm',
    MY: 'МалайзіяCountry name',
    NL: 'НідерландіяCountry name',
    NO: 'НорвегіяName',
    NZ: 'Нова ЗеландіяCountry name',
    RU: 'Росіяrussia_ subjects. kgm',
    SE: 'Швеціяworld. kgm',
    TW: 'Тайван, Китай',
    US: 'США',
    VN: 'Viet Nam',
  },
  'zh-CN': {
    AU: '澳大利亚',
    BR: '巴西',
    CN: '中国',
    DK: '丹麦',
    FI: '芬兰',
    FR: '法国',
    DE: '德国',
    HK: '中国香港特别行政区',
    IT: '意大利',
    IN: '印度',
    JP: '日本',
    KR: '韩国',
    MX: '墨西哥',
    MY: '马来西亚',
    NL: '荷兰',
    NO: '挪威',
    NZ: '新西兰',
    RU: '俄罗斯',
    SE: '瑞典',
    TW: '中国台湾',
    US: '美国',
    VN: '越南',
  },
  'zh-HK': {
    AU: '澳大利亞',
    BR: '巴西',
    CN: '中國',
    DK: '丹麥',
    FI: '芬蘭',
    FR: '法國',
    DE: '德國',
    HK: '中國香港特別行政區',
    IT: '義大利',
    IN: '印度',
    JP: '日本',
    KR: '韓國',
    MX: '墨西哥',
    MY: '馬來西亞',
    NL: '荷蘭',
    NO: '挪威',
    NZ: '紐西蘭',
    RU: '俄羅斯',
    SE: '瑞典',
    TW: '中國臺灣',
    US: '美國',
    VN: '越南',
  },
};

export const LANG_SWITCH_OPTIONS = [
  { value: 'zh-CN', label: '中文（简体）' },
  { value: 'zh-HK', label: '中文（繁体）' },
  { value: 'da', label: 'Dansk' },
  { value: 'de', label: 'Deutsch' },
  { value: 'en-US', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italiano' },
  { value: 'ja', label: '日本語' },
  { value: 'ko', label: '한국어' },
  { value: 'no', label: 'Norsk' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'pt-BR', label: 'Português(Brasil)' },
  { value: 'fi', label: 'Suomi' },
  { value: 'es', label: 'Español' },
  { value: 'sv', label: 'Svenska' },
  { value: 'ru', label: 'Pусский' },
  { value: 'uk', label: 'Український' },
  { value: 'ar', label: 'Arabic (Egypt)' },
];
export const RECAPTCHA_LANG_MAP: Record<string, string> = {
  zh: 'zh-CN',
  'zh-cn': 'zh-CN',
  'zh-CN': 'zh-CN',
  'zh-tw': 'zh-TW',
  'zh-TW': 'zh-TW',
  'zh-hk': 'zh-TW',
  'zh-HK': 'zh-TW',
  tw: 'zh-TW',
  hk: 'zh-TW',
  en: 'en',
  'en-us': 'en',
  'en-US': 'en',
  ar: 'ar',
  'ar-SA': 'ar',
  'ar-EG': 'ar',
  'ar-AE': 'ar',
  ja: 'ja',
  ko: 'ko',
  fr: 'fr',
  de: 'de',
  es: 'es',
  ru: 'ru',
  fi: 'fi',
  pt: 'pt',
  'pt-BR': 'pt',
  'pt-PT': 'pt',
  it: 'it',
  nl: 'nl',
  sv: 'sv',
  da: 'da',
  no: 'no',
  uk: 'uk',
};
